import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-navigation-waiting-icon',
  templateUrl: './navigation-waiting.component.html'
})
export class NavigationWaitingComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
